module.exports = __webpack_public_path__ + "static/media/image9.8904c440.png";